import React from "react";
import { Grid, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningIcon from "../../images/icons/WarningIcon.svg";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

interface Props {
  sendToPharmacyData: any;
}

function PrescribedStatusPopup(props: Props) {
  const { sendToPharmacyData } = props;
  console.log("sendToPharmacyData", sendToPharmacyData);

  return (
    <Grid
      container
      item
      xs={12}
      spacing={1}
      alignItems="top"
      justifyContent="center"
    >
      <Grid item xs={12} textAlign={"center"} marginTop={1}>
        {sendToPharmacyData?.length > 0 &&
          sendToPharmacyData[0]?.statusCode === 0 && (
            <CheckCircleOutlineIcon
              style={{ height: 70, width: 70 }}
              color="success"
            />
          )}
        {sendToPharmacyData?.length > 0 &&
          sendToPharmacyData[0]?.statusCode === 1 && (
            <img
              style={{ height: 40, width: 40 }}
              src={WarningIcon}
              alt="danger"
            />
          )}
        {sendToPharmacyData?.length > 0 &&
          sendToPharmacyData?.length > 0 &&
          sendToPharmacyData[0]?.statusCode === 2 && (
            <HighlightOffIcon style={{ height: 40, width: 40, fill: "red" }} />
          )}
      </Grid>
      {sendToPharmacyData?.map((each: any) => (
        <>
          {/* <Grid item xs={12} textAlign={"center"}>
            <Typography component="span" variant="subtitle2" fontWeight={600}>
              {each?.operation}
            </Typography>{" "}
          </Grid> */}

          <Grid item xs={12} textAlign={"center"}>
            <Typography component="span" variant="subtitle2">
              {each?.message}
            </Typography>{" "}
          </Grid>
        </>
      ))}
    </Grid>
  );
}

export default PrescribedStatusPopup;
